
























import { Component, Vue } from 'vue-property-decorator';
import { Mutations } from '@/ts/store/Constants';
import { mapGetters } from 'vuex';
import pdfvuer from 'pdfvuer';

@Component({
    components: {
        pdfvuer,
    },
    computed: {
        ...mapGetters({
            previewedDocumentExtention: 'WaitingLists/getPreviewedDocumentExtention',
            previewedDocumentData: 'WaitingLists/getPreviewedDocument',
        }),
    },
})
export default class PreviewDocument extends Vue {
    public pdfPageCount: number = 1;

    constructor() {
        super();
    }

    public closePreviewDocument() {
        this.$store.commit(Mutations.RESET_PREVIEW_DOCUMENT);
    }

    public downloadPreviewDocument() {
        saveAs(this.$store.getters['WaitingLists/getPreviewedDocument'], this.$store.getters['WaitingLists/getPreviewedDocumentOriginalName']);
    }

    get getPdfPageCount() {
        try {
            if (this.$store.getters['WaitingLists/getPreviewedDocument'] !== '' && this.$store.getters['WaitingLists/getPreviewedDocumentExtention'] === 'pdf') {
                const pdf = pdfvuer.createLoadingTask(this.$store.getters['WaitingLists/getPreviewedDocument']);
                pdf.then((pdfvuerInstance: any) => {
                    this.pdfPageCount = pdfvuerInstance.numPages;
                });
                return this.pdfPageCount;
            }
        } catch (error) {
            console.log(error);
        }
    }
}
